import { BreeSerifText } from "@Components/CustomText/BreeSerifText"
import { OpenSansText } from "@Components/CustomText/OpenSansText"
import React from "react"
import { View } from "react-native"
import { RFValue } from "react-native-responsive-fontsize"
import styles from "./styles"

const CustomSettingTitle = (props) => {
    const { icon, title, subTitle } = props

    return (
        <View style={styles.container}>
            <View style={styles.icon}>{icon ?? ""}</View>
            <View style={styles.titleContainer}>
                <BreeSerifText fontSize={RFValue(18)}>{title ?? ""}</BreeSerifText>
                <OpenSansText style={styles.subTitle} fontSize={RFValue(14)}>
                    {subTitle ?? ""}
                </OpenSansText>
            </View>
        </View>
    )
}

export default CustomSettingTitle
